<template>
    <base-notification-card
        v-bind="$attrs"
        @card-clicked="$emit('cardClicked', $attrs.id)">
        <template #avatar>
            <div class="bulk-avatar">
                <pendo-icon
                    type="settings"
                    size="16" />
            </div>
        </template>
        <template #content>
            <div class="body">
                {{ $attrs.body }}
            </div>
        </template>
    </base-notification-card>
</template>

<script>
import { PendoIcon } from '@pendo/components-vue3';
import BaseNotificationCard from './base-notification-card.vue';

export default {
    name: 'BulkNotificationCard',
    components: {
        PendoIcon,
        BaseNotificationCard,
    },
    inheritAttrs: false,
    emits: ['cardClicked'],
};
</script>

<style scoped lang="less">
.bulk-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    width: 32px;
    border-radius: 50%;
    border: 1.5px solid var(--palette-gray-30);
    background-color: var(--palette-gray-20);
    color: var(--palette-gray-70);

    :deep(.pendo-icon) {
        display: flex;
        stroke: var(--palette-gray-70);
    }
}

.body {
    color: var(--palette-gray-70);
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
}
</style>
